import React from 'react';
import { Link } from 'react-router-dom';
import '../css/cookie-consent-banner.css';

export const COOKIE_CONSENT_KEY = 'rm_cookie_consent_v1';

export function getStoredCookieConsent() {
    try {
        const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (typeof parsed !== 'object' || parsed === null) return null;
        const analytics = Boolean(parsed.analytics);
        return {
            necessary: true,
            analytics,
            updatedAt: parsed.updatedAt || null
        };
    } catch (error) {
        return null;
    }
}

function saveCookieConsent(analyticsEnabled) {
    const payload = {
        necessary: true,
        analytics: Boolean(analyticsEnabled),
        updatedAt: new Date().toISOString()
    };

    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(payload));
    window.dispatchEvent(new Event('cookie-consent-updated'));
}

export function hasAnalyticsConsent() {
    return Boolean(getStoredCookieConsent()?.analytics);
}

export function CookieConsentBanner() {
    const [consent, setConsent] = React.useState(() => getStoredCookieConsent());

    React.useEffect(() => {
        const onConsentUpdated = () => {
            setConsent(getStoredCookieConsent());
        };

        window.addEventListener('cookie-consent-updated', onConsentUpdated);
        return () => window.removeEventListener('cookie-consent-updated', onConsentUpdated);
    }, []);

    if (consent) return null;

    return (
        <aside className="cookie-consent-banner" role="dialog" aria-live="polite" aria-label="Cookie preferences">
            <div className="cookie-consent-content">
                <p className="cookie-consent-title">We use cookies</p>
                <p className="cookie-consent-copy">
                    We use essential cookies to keep this site secure and working. Optional analytics cookies help us improve performance.
                    See our <Link to="/privacy-policy">Privacy Policy</Link> for details.
                </p>
            </div>
            <div className="cookie-consent-actions">
                <button
                    type="button"
                    className="cookie-consent-btn cookie-consent-btn-secondary"
                    onClick={() => saveCookieConsent(false)}
                >
                    Essential Only
                </button>
                <button
                    type="button"
                    className="cookie-consent-btn cookie-consent-btn-primary"
                    onClick={() => saveCookieConsent(true)}
                >
                    Accept All
                </button>
            </div>
        </aside>
    );
}
